module.exports = __webpack_public_path__ + "img/nav-3-1.ca69c530.png";